import { Component } from '@theme/component';

class ProductCustomProperty extends Component {
  #visibilityTimer;
  #requiredFields = new Map();
  #disabledFields = new Map();

  connectedCallback() {
    super.connectedCallback();
    // Only the marked LOVPOST block gets conditional visibility.
    this.#updateVisibility();
    if (this.querySelector('[data-lovpost-allowed-variants]')) {
      // Read the actual product-form variant ID, including programmatic updates.
      this.#visibilityTimer = window.setInterval(() => this.#updateVisibility(), 150);
    }
  }

  disconnectedCallback() {
    window.clearInterval(this.#visibilityTimer);
    super.disconnectedCallback();
  }

  #updateVisibility() {
    const wrapper = this.querySelector('[data-lovpost-allowed-variants]');
    if (!wrapper) return;
    const form = document.getElementById(wrapper.dataset.lovpostFormId);
    const variantInput = form?.querySelector('[name="id"]');
    const excludedVariantId = '55110164578646';
    const selectedVariantId = String(variantInput?.value || '');
    const visible =
      selectedVariantId !== '' &&
      selectedVariantId !== excludedVariantId;


    if (visible) {
      this.style.removeProperty('display');
    } else {
      this.style.setProperty('display', 'none', 'important');
    }

    wrapper.querySelectorAll('input, textarea, select').forEach(field => {
      if (!this.#requiredFields.has(field)) {
        this.#requiredFields.set(field, field.required);
        this.#disabledFields.set(field, field.disabled);
      }
      field.required = visible && this.#requiredFields.get(field);
      field.disabled = !visible || this.#disabledFields.get(field);
      if (field.required) field.setAttribute('aria-required', 'true');
      else field.removeAttribute('aria-required');
    });
  }

  handleInput() {
    this.#updateCharacterCount();
  }

  #updateCharacterCount() {
    const { characterCount, textInput } = this.refs;
    if (!characterCount || !textInput) return;
    const template = characterCount.getAttribute('data-template');
    if (!template) return;
    characterCount.textContent = template
      .replace('[current]', textInput.value.length.toString())
      .replace('[max]', textInput.maxLength.toString());
  }
}

if (!customElements.get('product-custom-property-component')) {
  customElements.define('product-custom-property-component', ProductCustomProperty);
}
